import * as Scrivito from "scrivito";
import moment from "moment";
import I18n from "^/config/i18n";
import { formatDateRange } from "^/utils/formatDateRange";

import ImageOrVideo from "../../Components/ImageOrVideo";
import InPlaceEditingPlaceholder from "../../Components/InPlaceEditingPlaceholder";

export const EventWidgetComponent = Scrivito.connect(({ widget }) => {
  const page = widget.get("destination");
  const currentHour = moment().startOf("day").toDate();

  if (!page) {
    return <div className="alert alert-warning">No Event selected.</div>;
  }

  const date = page.get("date");
  const endDate = page.get("endDate");
  const language = page.language();
  if (page.get("endDate") < currentHour && page.get("endDate") !== null) {
    return (
      <InPlaceEditingPlaceholder center>
        This event is out of date
        <Scrivito.LinkTag to={page} className="btn bg-blue p-1 d-block m-auto">
          Got to Event
        </Scrivito.LinkTag>
      </InPlaceEditingPlaceholder>
    );
  }

  return (
    <Scrivito.WidgetTag className="teaser-box --event">
      <Scrivito.LinkTag
        to={page}
        className="teaser-box__wrapper d-block bg-white"
      >
        <ImageOrVideo
          widget={page}
          teaser={true}
          className="teaser-box__image"
        />
        <div className="teaser-box-content">
          <div className="teaser-box__additional">
            {formatDateRange(date, endDate, {
              locale: language || "de",
              allDay: page.get("allDay"),
            })}
          </div>
          <Scrivito.ContentTag
            content={page}
            attribute="title"
            tag="h4"
            className="teaser-box__title"
          />
          <Scrivito.ContentTag
            content={page}
            attribute="shortDescription"
            tag="div"
            className="teaser-box__description"
          />
          <span className="teaser-box__button">
            <i className="las la-angle-right me-2"></i>
            {I18n.t("Event to event")}
          </span>
        </div>
      </Scrivito.LinkTag>
    </Scrivito.WidgetTag>
  );
});

Scrivito.provideComponent("EventWidget", EventWidgetComponent);
